module.exports = __webpack_public_path__ + "static/media/spotify.efa738db.svg";